(function(){
"use strict";
if(new URLSearchParams(location.search).get("kira_editorial")==="0")return;
function init(){
 const player=document.getElementById("kpAcabadosPlayer");
 const video=document.getElementById("kpAcabadosVideo");
 const play=document.getElementById("kpAcabadosPlayBtn");
 if(!player||!video||!play||player.dataset.kiraV6Init)return;
 player.dataset.kiraV6Init="1";
 // Conservamos el póster de producto ya configurado: el código original dibuja la portada como fondo.
 // El vídeo, su carga diferida y el botón de reproducción siguen intactos.
 const intro=document.createElement("div");
 intro.className="kira-v6-video-hook";
 intro.setAttribute("aria-hidden","true");
 const top=document.createElement("span");
 top.className="kira-v6-video-hook__eyebrow";
 top.textContent="KIRA CASES / VIDEO REAL";
 const title=document.createElement("strong");
 title.className="kira-v6-video-hook__title";
 title.textContent="UN DISEÑO. CUATRO ACABADOS.";
 const sub=document.createElement("span");
 sub.className="kira-v6-video-hook__sub";
 sub.textContent="Mira cómo se ven en una funda real.";
 intro.append(top,title,sub);
 player.insertBefore(intro,play);
 play.setAttribute("aria-label","Reproducir comparación real de cuatro acabados");
 // El video ya se reproduce en silencio desde su código original.
 video.defaultMuted=true;
 video.muted=true;
 const protect=document.querySelector("[data-kp-protection-video]");
 if(protect){
   protect.defaultMuted=true;
   protect.muted=true;
 }
}
if(document.readyState==="loading")document.addEventListener("DOMContentLoaded",init,{once:true});else init();
})();